import {doc, getDocs, collection, query, where} from "firebase/firestore";
import {fire} from "../../fire";

export const obtenerColWheres = ({coleccion, wheres=[]}) => {

    let q = query(collection(fire, coleccion), ...wheres)

    return new Promise(resolve => {
        getDocs(q).then((dox) => {

            let arr = []
            for (let i = 0; i < dox.docs.length; i++) {
                arr.push(dox.docs[i].data())
            }

            return resolve({res: true, data: arr})
        }).catch((err) => {
            return resolve({res: false, data: err.message})
        })
    })

}